import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { LoaderIndex } from "../Loader/LoaderIndex";

const UserDetailsModal = ({ show, onHide, userData }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>User Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {userData ? (
          <table className="table table-bordered">
            <tbody>
              <tr>
                <th>Email</th>
                <td>{userData?.email || "N/A"}</td>
              </tr>
              <tr>
                <th>Role</th>
                <td>{userData?.role || "N/A"}</td>
              </tr>
              <tr>
                <th>Doctor Role</th>
                <td>{userData?.info?.dr_role || "N/A"}</td>
              </tr>
              <tr>
                <th>Practice Framework</th>
                <td>{userData?.info?.practice_framework?.name || "N/A"}</td>
              </tr>
              <tr>
                <th>Diagnostic Tool</th>
                <td>{userData?.info?.diagnostic_tool?.name || "N/A"}</td>
              </tr>
              <tr>
                <th>Subscription End Date</th>
                <td>
                  {userData?.subscription?.subscription_enddate
                    ? userData.subscription.subscription_enddate.split("T")[0]
                    : "N/A"}
                </td>
              </tr>
              <tr>
                <th>Account Created At</th>
                <td>{userData?.created_at?.split("T")[0] || "N/A"}</td>
              </tr>
              <tr>
                <th>Is Banned</th>
                <td>{userData?.is_banned ? "Yes" : "No"}</td>
              </tr>
            </tbody>
          </table>
        ) : (
          <p className="text-muted">No user details available.</p>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default UserDetailsModal;
